import {Injectable} from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/modules/login/login.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

  private errorMessages:string[] = [];

  constructor(
    private messageService:MessageService,
    private router: Router,
    private loginService: LoginService
  ) {
  }
  
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError(error => {
        console.log(error);

        //TODO: creara ventana mas completa para mostrar errores
        //procesamos errores
        var details = "";
        if(error.error?.errors){
          for(var key in error.error.errors){
            details += error.error.errors[key].detail;
            this.messageService.add({ closable: true, severity: 'error', summary: 'Error', detail: error.error.errors[key].detail });
          }
        }else if(error.error?.detail){
          //rfc9110
          this.messageService.add({ closable: true, severity: 'error', summary: 'Error', detail: error.error?.detail });
        }else {
          let errorTitle = 'Error';
          let errorMessage = 'Error desconocido';
          let showAlert = true;
          if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
              errorMessage = 'Error de conexión, intentelo de nuevo por favor.';
            }else if(error.status === 401){
              errorTitle += ' 401';
              errorMessage = 'No autorizado: ' + req.url;
              showAlert = false;
              this.loginService.logout();
            }else if(error.status === 403){
              errorTitle += ' 403';
              errorMessage = 'Prohibido: ' + req.url;
            }else if(error.status === 404){
              errorTitle += ' 404';
              errorMessage = 'No encontrado: ' + req.url;
            }
          }
          if(showAlert){
            //comprobamos siya existe un mensaje igual, para no repetirlo
            if(this.errorMessages.indexOf(errorMessage) < 0){
              let message:ToastMessageOptions = { closable: true, severity: 'error', summary: errorTitle, detail: errorMessage };
              this.messageService.add(message);
              this.errorMessages.push(errorMessage);
              
              //a los 3 segundos eliminamos el mensaje añadido
              setTimeout(() => {
                this.errorMessages.splice(this.errorMessages.indexOf(errorMessage), 1);
              }, 3000);
            }
          }else{
            console.error(errorTitle + ': ' + errorMessage);
          }
        }
        
        return throwError(error);
      })
    );
  }
}